import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgQuickPickupOutline16 = function SvgQuickPickupOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15v.4h.408l-.008-.408zm-12.654 0h-.4v.4h.4zm0-11.76v-.4h-.4v.4zm12.41 0 .4-.008-.008-.392h-.391zm-8.984 1.68v.4h.8v-.4zm4.708 0v.4h.8v-.4zM7.333 4.267a.4.4 0 1 0 0-.8zM1 3.467a.4.4 0 0 0 0 .8zm6.333 2.48a.4.4 0 0 0 0-.8zm-3.096-.8a.4.4 0 1 0 0 .8zm3.096 2.76a.4.4 0 0 0 0-.8zm-1.33-.8a.4.4 0 1 0 0 .8zM23 14.6H10.346v.8H23zm-12.254.4V3.24h-.8V15zm-.4-11.36h12.41v-.8h-12.41zm12.01-.392.244 11.76.8-.016-.243-11.76zM14.573 4.92V2.96h-.8v1.96zm0-1.96c0-.796.803-1.56 1.954-1.56V.6c-1.45 0-2.754.991-2.754 2.36zm1.954-1.56c1.15 0 1.954.764 1.954 1.56h.8c0-1.369-1.305-2.36-2.754-2.36zm1.954 1.56v1.96h.8V2.96zm-11.147.507H1v.8h6.333zm0 1.68H4.237v.8h3.096zm0 1.96h-1.33v.8h1.33z",
    fill: "currentColor"
  })));
};

var QuickPickupOutline16Svg = SvgQuickPickupOutline16;

export { QuickPickupOutline16Svg as default };
//# sourceMappingURL=QuickPickupOutline16.svg.js.map
